export default {
  header: "Cinemetrics",
  view: "Home",
  trending: [],
  nowPlaying: [],
  popular: [],
  topRated: []
};
